import React, { useEffect } from 'react';

import { useMytaverseEvent } from '@core/dashboard/providers';
import useChatHandlers from '@core/chat/hooks/useChatHandlers';
import withMytaverseEventProviders from '@hoc/withMytaverseEventProvider';
import EventPageView from './EventPageView';

const EventPage = () => {
  const {
    currentEvent,
    streamChatToken,
    openAdminSettingsModal,
    setIsUserEnteringEvent,
  } = useMytaverseEvent();

  useChatHandlers({ currentEvent, streamChatToken });

  useEffect(() => {
    setIsUserEnteringEvent(true);
  }, [setIsUserEnteringEvent]);

  return <EventPageView openAdminSettingsModal={openAdminSettingsModal} />;
};

export default withMytaverseEventProviders(EventPage);
